import { Helmet } from "react-helmet-async";

type PageMetaProps = {
  title: string;
  description: string;
  path: string;
};

const siteUrl = "https://github.com/allstarcom/7StonesWeb";

export function PageMeta({ title, description, path }: PageMetaProps) {
  const canonical = `${siteUrl}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
